import React, {
  useState,
  useRef,
  setState,
  useEffect,
  useCallback,
} from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./ScheduleTbl.css";
import Time from "react-time";
import { DelayInput } from "react-delay-input";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import axios from "axios";
import GameModify from "../GameModify";
import ModifyBanner from "../ModifyBanner";
import GameStatus from "../GameStatus";
import CreateGame from "../CreateGame";
import CreateBanner from "../CreateBanner";
import DeleteGame from "../DeleteGame";
import ChartingInfo from "../ChartingInfo";
import GamePeriods from "../games/gameComponents/GamePeriod";
import HideGames from "../games/gameComponents/HideGames";
import GameSettingsByLt from "../games/gameComponents/GameSettingsByLt";
import Paper from "@material-ui/core/Paper";
import Link from "@material-ui/core/Link";
import Checkbox from "@material-ui/core/Checkbox";
import KeyboardEventHandler from "react-keyboard-event-handler";
import clsx from "clsx";
import { windowsColorToHex } from "../../utils/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  table: {
    borderRadius: 10,
    overflow: "hidden",
  },
  tableHead: {
    backgroundColor: "#f8f9fb",
  },
  columnHeader: {
    backgroundColor: "#f8f9fb",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "#6b7280",
  },
}));
const useStylesCheck = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxSizing: "border-box",
    position: "relative",
    border: "1.5px solid rgba(0,0,0,0.28)",
    backgroundColor: "white",
    boxShadow: "none",
    "$root.Mui-focusVisible &": {
      outline: "1px auto rgba(99,102,241,.6)",
      outlineOffset: 1,
    },
    "input:hover ~ &": {
      borderColor: "#6366f1",
    },
    "input:disabled ~ &": {
      border: "1.5px solid rgba(0,0,0,0.12)",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    borderColor: "#6366f1",
    backgroundColor: "white",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 7,
      height: 7,
      borderRadius: "50%",
      backgroundColor: "#6366f1",
    },
    "input:hover ~ &": {
      borderColor: "#4f46e5",
    },
  },
});
export default function ScheduleTNT(props) {
  const classes = useStyles();
  const classCheck = useStylesCheck();

  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + " " + time;

  const [selectedIdGame, setselectedIdGame] = useState();
  const [rotation, setRotation] = useState();
  const [selectedPlay, setselectedPlay] = useState();
  const [points, setPoints] = useState();
  const [selectedIdLeague, setselectedIdLeague] = useState();
  const [selectedLeagueName, setSelectedLeagueName] = useState("");
  const [isModify, setIsModify] = useState(false);
  const [isModifyBanner, setIsModifyBanner] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isPeriod, setIsPeriod] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isCharting, setIsCharting] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [newBanner, setNewBanner] = useState(false);
  const [parentGame, setParentGame] = useState();
  const [homeNumber, setHomeNumber] = useState();
  const [visitorNumber, setVisitorNumber] = useState();
  const [homeTeam, setHomeTeam] = useState();
  const [visitorTeam, setVisitorTeam] = useState();
  const [gameDateTime, setGameDateTime] = useState();
  const [recentUpdatedGame, setRecentUpdatedGame] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [currentPage, setCurrentPage] = useState(0);
  const [valueHasChanged, setValueHasChanged] = useState(1);
  const [isChecked, setisChecked] = useState(false);
  const [tempUpdates, setTempUpdates] = useState(new Map());

  const rowRefs = useRef({});
  const [recentUpdatedRow, setRecentUpdatedRow] = useState(null);
  const [highlightRow, setHighlightRow] = useState(null);
  const [lineHistoryModal, setLineHistoryModal] = useState(false);
    const [linesHistoryVisitor, setLinesHistoryVisitor] = useState([]);
    const [linesHistoryHome, setLinesHistoryHome] = useState([]);
    const [rowSelected, setRowSelected] = useState({});
    const [isDraw,setIsDraw] = useState(false);
  
  
    async function GetLinesHistoryVisitor(row, play, teamNumber) {
      setLinesHistoryVisitor([]);
      const requestDto = {
        prmIdGame: row.idGame,      
        prmIdLineType: props.IdLinetype,        
        prmIdSport: props.IdSport,       
        prmTeamNumber: teamNumber,    
        prmPlay: play,          
        prmColumnNumber: 0    
      };
  
      try {
        const response = await axios.post(
          process.env.REACT_APP_API2_URL + "/game/SystemChangedLines_GetChanges",
          requestDto
        );
        console.log("Datos recibidos:", response.data);
        setLinesHistoryVisitor(response.data);
        setRowSelected(row);
        setLineHistoryModal(true);
      } catch (error) {
        console.error("Error al obtener cambios de líneas:", error);
      }
    }  
    
  const TOL_MS = 100;
  
  const mergedRows = React.useMemo(() => {
    const v = (linesHistoryVisitor ?? [])
      .map(x => ({ ...x, ts: new Date(x.PlacedDate).getTime() }))
      .sort((a, b) => a.ts - b.ts);
    const h = (linesHistoryHome ?? [])
      .map(x => ({ ...x, ts: new Date(x.PlacedDate).getTime() }))
      .sort((a, b) => a.ts - b.ts);
  
    const out = [];
    let i = 0, j = 0;
  
    while (i < v.length || j < h.length) {
      const vi = v[i];
      const hi = h[j];
  
      if (vi && hi) {
        const diff = Math.abs(vi.ts - hi.ts);
        if (diff <= TOL_MS) {
  
          out.push({
            time: new Date(Math.min(vi.ts, hi.ts)),
            visitor: vi.ChangeValue ?? "",
            home: hi.ChangeValue ?? "",
          });
          i++; j++;
          continue;
        }
       
        if (vi.ts < hi.ts) {
          out.push({ time: new Date(vi.ts), visitor: vi.ChangeValue ?? "", home: "" });
          i++;
        } else {
          out.push({ time: new Date(hi.ts), visitor: "", home: hi.ChangeValue ?? "" });
          j++;
        }
        continue;
      }
  
      if (vi) { out.push({ time: new Date(vi.ts), visitor: vi.ChangeValue ?? "", home: "" }); i++; }
      if (hi) { out.push({ time: new Date(hi.ts), visitor: "", home: hi.ChangeValue ?? "" }); j++; }
    }
  
  
    return out.sort((a, b) => b.time - a.time);
  }, [linesHistoryVisitor, linesHistoryHome]);
  
  const fmt = d => d?.toLocaleString(undefined, { hour12: true }) ?? "";

  useEffect(() => {
      if (recentUpdatedRow && rowRefs.current[recentUpdatedRow]) {
        rowRefs.current[recentUpdatedRow]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
  
        setHighlightRow(recentUpdatedRow);
  
        const timer = setTimeout(() => {
          setHighlightRow(null);
        }, 3000);
  
        return () => clearTimeout(timer);
      }
    }, [props.data]);

  const setEventKey = function (key, e) {
    if (key === "alt+d") {
      if (isChecked) {
        setIsDelete(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+i") {
      if (isChecked) {
        setIsPeriod(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+m") {
      if (isChecked) {
        setIsModify(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+b") {
      if (isChecked) {
        setNewBanner(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+t") {
      if (isChecked) {
        setIsSettings(true);
      } else {
        alert("You must select a game");
      }
    } else if (key === "alt+n") {
      setIsNew(true);
    } else if (key === "alt+s") {
      if (isChecked) {
        setIsStatus(true);
      } else {
        alert("You must select a game");
      }
    }
  };

  const saveTempUpdate = (row, value) => {
    setTempUpdates((prev) => {
      const newUpdates = new Map(prev);
      if (newUpdates.has(row.visitorNumber)) {
        newUpdates.set(row.visitorNumber, {
          ...newUpdates.get(row.visitorNumber),
          VisitorOdds: value,
        });
      } else {
        newUpdates.set(row.visitorNumber, {
          IdGame: row.idGame,
          OverOdds: row.overOdds,
          IdLinetype: props.IdLinetype,
          VisitorOdds: value,
          IdSport: props.IdSport,
          VisitorNumber: row.visitorNumber,
          HomeNumber: row.homeNumber,
          IdGameType: row.idGameType,
        });
      }
      return newUpdates;
    });
  };

  const sendAllUpdates = (row,value) => {
    let updatesClone = new Map(tempUpdates);
    if (updatesClone.has(row.visitorNumber)) {
      updatesClone.set(row.visitorNumber, {
        ...updatesClone.get(row.visitorNumber),
        VisitorOdds: value,
      });
    } else {
      updatesClone.set(row.visitorNumber, {
        IdGame: row.idGame,
        OverOdds: row.overOdds,
        IdLinetype: props.IdLinetype,
        VisitorOdds: value,
        IdSport: props.IdSport,
        VisitorNumber: row.visitorNumber,
        HomeNumber: row.homeNumber,
        IdGameType: row.idGameType,
      });
    }
    
    if (updatesClone.size > 0) {
      const updatesArray = Array.from(updatesClone.values()).map(update => ({
        IdLinetype: update.IdLinetype,
        IdGame: update.idGame,
        TeamNumber: update.VisitorNumber,
        Odds: update.VisitorOdds,
        IdSport: update.IdSport,
        ChangeLine: 1, 
        ChangeOdds: 0, 
        NewValue: update.VisitorOdds,
        Play: 4,
        IdUser: 0,
        Column: 8,
      }));
      console.log("Enviando datos:", updatesArray);
      updateML2(updatesArray);
      // setTempUpdates(new Map());
    }
  };

  const updateML2 = async (updatesArray) => {
    if (updatesArray.length === 0) return;
  
    props.setIsLoading(true);
    const lastUpdate = updatesArray[updatesArray.length - 1];
    const lastIdGame = lastUpdate ? lastUpdate.idGame : null;
    setRecentUpdatedGame(lastIdGame);
    setRecentUpdatedRow(lastIdGame);
    try {
      await axios.post(
        process.env.REACT_APP_API2_URL + "/Wager/MoveTNT",
        updatesArray
      );
  
      props.setIsLoading(false);
      setTempUpdates(new Map());
      props.searchGameValues();
    } catch (error) {
      props.setIsLoading(false);
      console.error("Error UpdateML:", error);
    }
  };

  const updateML = async (
    idGame,
    odds,
    idLinetype,
    newValue, // linea
    idSport,
    teamNumber,
    play,
    column,
    changeLine,
    changeOdds,
    otherTeam,
    IdGameType,
    otherColumn,
    otherPlay,
    event
  ) => {
    props.setIsLoading(true);
    setRecentUpdatedGame(idGame);
    setRecentUpdatedRow(idGame);
    props.setLastChangedGamedID(idGame);
    try {
      let drawObject = {
        IdLinetype: idLinetype, // Corregido
        IdGame: idGame,
        TeamNumber: teamNumber,
        Odds: newValue,
        IdSport: idSport,
        ChangeLine: changeLine,
        ChangeOdds: changeOdds,
        NewValue: newValue,
        Play: play,
        IdUser: 0,
        Column: column,
      };
  
        // Inserta datos en GameTNTPROP_SetChangedValues
        await axios({
          method: "post",
          url: process.env.REACT_APP_API2_URL + '/Wager/MoveTNT',
          data: drawObject,
        });
      // Finaliza la búsqueda de valores del juego
      props.setIsLoading(false);
      props.searchGameValues();

      
    } catch (error) {
      props.setIsLoading(false);
    }
  };
  
  const isGameDateTimePassed = (gameDateTime) => {
    const now = new Date();
    const gameDate = new Date(gameDateTime);
    const nowEastern = toEasternTime(now);
   
    return !(nowEastern < gameDate);
  };

  function toEasternTime(date) {
    const options = { timeZone: "America/New_York", hour12: false };
    const formatter = new Intl.DateTimeFormat("en-US", {
      ...options,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  
    const [
      month, day, year, hour, minute, second,
    ] = formatter
      .formatToParts(date)
      .filter(part => part.type !== "literal")
      .map(part => part.value);
  
    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  }




  useEffect(() => setRecentUpdatedGame(props.getRecentGame()));

  useEffect(() => {
    if (props.selectedGame.length > 0) {
      setisChecked(true);
    } else {
      setisChecked(false);
    }
    console.log(props)
  });

  const handleCloseModify = function () {
    setIsModify(false);
  };
  const handleCloseBannerModify = function () {
    setIsModifyBanner(false);
  };
  const handleCloseCharting = function () {
    setIsCharting(false);
  };
  const handleCloseHideGames = function () {
    setIsHidden(false);
  };
  const handleCloseStatus = function () {
    setIsStatus(false);
  };
  const handleCloseCreate = function () {
    setIsNew(false);
  };
  const handleDelete = function () {
    setIsDelete(false);
  };
  const handlePeriods = function () {
    setIsPeriod(false);
  };
  const handleSettings = function () {
    setIsSettings(false);
  };
  const handleCloseNewBanner = function () {
    setNewBanner(false);
  };
  const pageNumbers = [];
  if (props.data) {
    for (let i = 1; i <= Math.ceil(props.data.length); i++) {
      pageNumbers.push(i);
    }
  }
  function handleClick(event, newPage) {
    setCurrentPage(newPage);
  }
  const handleChange = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(0);
  };

  const getStyle = (gameStat, gameDateTime) => {
    let style = "";

    let dateToday = new Date(dateTime);
    let dateGame = new Date(gameDateTime.date);
    if (gameStat == "D") {
      style = "schedule-closed";
    } else if (dateGame < dateToday) {
      style = "schedule-offboard";
    }
    return style;
  };

  const [datesRow,setDatesRow] = useState([])
  const handleClickCheckEvent = (
    event,
    name,
    idLeagueSelected,
    parentGame,
    homeNumber,
    visitorNumber,
    visitorOdds,
    row
  ) => {
    //SI CAMBIAS ACA EL SEGUNDO NAME POR VisitorNumber puedes hacer que se marque por individual, pero no se si debe marcarse todo el game o por separado
    props.handleClickCheck(name, name);

    setselectedIdLeague(idLeagueSelected);
    setSelectedLeagueName(row?.LeagueDescription || "");
    setParentGame(parentGame);
    setHomeNumber(homeNumber);
    setVisitorNumber(visitorNumber);
    setRotation(visitorOdds);

    if (event.target.checked) {
      setDatesRow((prev) => [...prev, row]);
    } else {
      setDatesRow((prev) => prev.filter((item) => item.IdGame !== name));
    }
  };

  //TAMBIEN DEBES CAMBIAR EL SEGUNDO NAME COMO name2
  const isSelected = (name, name2) =>
    props.IdSport.trim() !== "TNT"
      ? props.selectedGame.indexOf(name) !== -1
      : props.selectedGame.indexOf(name) !== -1;

  const handleContextMenu = useCallback((e) => {
    // e.preventDefault();
  });

   useEffect(()=>{
      resetDatesRow();
    },[props.data])
    
  const resetDatesRow=()=>{
    setDatesRow([])
  }

  document.addEventListener("contextmenu", handleContextMenu);
  //document.addEventListener('contextmenu', useEventListener);
  const useEventListener1 = (eventName, handler, element = window) => {
    // Create a ref that stores handler
    const savedHandler = useRef();

    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    useEffect(() => {
      savedHandler.current = handler;
    }, [handler]);

    useEffect(
      () => {
        // Make sure element supports addEventListener
        // On
        const isSupported = element && element.addEventListener;
        if (!isSupported) return;

        // Create event listener that calls handler function stored in ref
        const eventListener = (event) => savedHandler.current(event);

        // Add event listener
        element.addEventListener(eventName, eventListener);

        // Remove event listener on cleanup
        return () => {
          element.removeEventListener(eventName, eventListener);
        };
      },
      [eventName, element] // Re-run if eventName or element changes
    );
  };
  function StyledCheckbox(props) {
    const classesCk = useStylesCheck();


    return (
      <Checkbox
        className={classesCk.root}
        disableRipple
        color="default"
        checkedIcon={
          <span className={clsx(classesCk.icon, classesCk.checkedIcon)} />
        }
        icon={<span className={classesCk.icon} />}
        inputProps={{ "aria-label": "decorative checkbox" }}
        {...props}
      />
    );
  }
  // useEventListener1('mousemove', handler);
  let previousRow = null;
  return (
    <React.Fragment>
      <KeyboardEventHandler
        handleKeys={[
          "alt+d",
          "alt+i",
          "alt+m",
          "alt+b",
          "alt+t",
          "alt+s",
          "alt+n",
        ]}
        onKeyEvent={(key, e) => setEventKey(key, e)}
      />
      {isNew ? (
        <CreateGame
          IdLinetype={props.IdLinetype}
          IdSport={props.IdSport.trim()}
          onClose={handleCloseCreate}
          searchGameValues={props.searchGameValues}
        />
      ) : (
          ""
        )}

      <div className="table-toolbar">
        <div
          className="toolbar-item toolbar-item-primary"
          onClick={() => {
            setIsNew(true);
          }}
        >
          <span>Add Games</span>
        </div>
        {isChecked ? (
          <>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsDelete(true);
              }}
            >
              <span>Delete Game</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsPeriod(true);
              }}
            >
              <span>Game Periods</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setNewBanner(true);
              }}
            >
              <span>Add Banner</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsStatus(true);
              }}
            >
              <span>Game Status</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsModify(true);
              }}
            >
              <span>Modify Game</span>
            </div>
            <div
              className="toolbar-item"
              onClick={() => {
                setIsSettings(true);
              }}
            >
              <span>Settings</span>
            </div>
            {props.selectedGame.length === 1 ? (
              <div
                className="toolbar-item"
                onClick={() => {
                  setIsHidden(true);
                }}
              >
                <span>Hide Values</span>
              </div>
            ) : (
                ""
              )}
          </>
        ) : (
            ""
          )}
      </div>
      <div className="schedule" style={{ width: "100%", marginTop: "16px", maxHeight: "75vh" }}>
        <Table
          className={classes.table}
          component={Paper}
          aria-label="a dense table"
        >
          {newBanner ? (
            <CreateBanner
              IdGames={props.selectedGame}
              IdSport={props.IdSport}
              IdLeague={selectedIdLeague}
              GameDateTime={gameDateTime}
              HomeNumber={homeNumber}
              VisitorNumber={visitorNumber}
              onClose={handleCloseNewBanner}
              searchGameValues={props.searchGameValues}
              clearArray={props.ClearArrar}
            />
          ) : (
              ""
            )}
          {isModify ? (
            <GameModify
              IdGames={props.selectedGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport.trim()}
              onClose={handleCloseModify}
              searchGameValues={props.searchGameValues}
              clearArray={props.ClearArrar}
              datesRow= {datesRow}
              resetDatesRow = {resetDatesRow}
            />
          ) : (
              ""
            )}
          {isModifyBanner ? (
            <ModifyBanner
              IdGames={selectedIdGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport}
              onClose={handleCloseBannerModify}
              searchGameValues={props.searchGameValues}
            />
          ) : (
              ""
            )}
          {isStatus ? (
            <GameStatus
              IdGames={props.selectedGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport.trim()}
              rotation={props.selectedGame[0]}
              onClose={handleCloseStatus}
              searchGameValues={props.searchGameValues}
              clearArray={props.ClearArrar}
              IdGameTNT={props.IdGameTNT}
              IdLeague={selectedIdLeague}
              LeagueName={selectedLeagueName}
            />
          ) : (
              ""
            )}

          {isDelete ? (
            <DeleteGame
              IdGames={props.selectedGame}
              clearArray={props.ClearArrar}
              searchGameValues={props.searchGameValues}
              onClose={handleDelete}
            />
          ) : (
              ""
            )}

          {isPeriod ? (
            <GamePeriods
              IdSport={props.IdSport}
              IdGames={props.selectedGame}
              clearArray={props.ClearArrar}
              onClose={handlePeriods}
              searchGameValues={props.searchGameValues}
            />
          ) : (
              ""
            )}

          {isSettings ? (
            <GameSettingsByLt
              IdGame={props.selectedGame}
              IdLinetype={props.IdLinetype}
              clearArray={props.ClearArrar}
              onClose={handleSettings}
              searchGameValues={props.searchGameValues}
            />
          ) : (
              ""
            )}

          {isCharting ? (
            <ChartingInfo
              IdGame={selectedIdGame}
              IdLinetype={props.IdLinetype}
              IdSport={props.IdSport}
              HomeTeam={homeTeam}
              VisitorTeam={visitorTeam}
              ActionType={0}
              Play={selectedPlay}
              Points={points}
              onClose={handleCloseCharting}
            />
          ) : (
              ""
            )}
          {isHidden ? (
            <HideGames
              IdGame={props.selectedGame}
              onClose={handleCloseHideGames}
              IdSport={props.IdSport}
            />
          ) : (
              ""
            )}

          <TableHead className={`${classes.tableHead} sticky top-0 z-50`}>
            <TableRow>
              <TableCell className={classes.columnHeader}>
                <strong>Date</strong>
              </TableCell>
              <TableCell className={classes.columnHeader}>
                <strong>Rotation</strong>
              </TableCell>
              <TableCell className={classes.columnHeader}>
                <strong>Match</strong>
              </TableCell>
              <TableCell className={classes.columnHeader}>
                <strong>ML</strong>
              </TableCell>

              <TableCell className={classes.columnHeader}>
                <strong>Action</strong>
              </TableCell>
              <TableCell className={classes.columnHeader}>
                <strong>Sum</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
  {props.data &&
    props.data
      .filter((e) => {
        const matchesFilter =
          e.HomeTeam?.toLowerCase().includes(props.filterStr.toLowerCase()) ||
          e.VisitorTeam?.toLowerCase().includes(props.filterStr.toLowerCase()) ||
          e.HomeNumber?.toString()
            .toLowerCase()
            .includes(props.filterStr.toLowerCase()) ||
          e.VisitorNumber?.toString()
            .toLowerCase()
            .includes(props.filterStr.toLowerCase()) ||
          e.HomeOdds?.toString()
            .toLowerCase()
            .includes(props.filterStr.toLowerCase()) ||
          e.VisitorOdds?.toString()
            .toLowerCase()
            .includes(props.filterStr.toLowerCase());

        // Si coincide con el filtro o si comparte el mismo IdLeague con una coincidencia previa
        return matchesFilter || props.data.some((row) => 
          row.idLeague === e.idLeague && row.idGame === e.idGame &&
          (row.homeTeam?.toLowerCase().includes(props.filterStr.toLowerCase()) ||
           row.visitorTeam?.toLowerCase().includes(props.filterStr.toLowerCase()) ||
           row.homeNumber?.toString()
             .toLowerCase()
             .includes(props.filterStr.toLowerCase()) ||
           row.visitorNumber?.toString()
             .toLowerCase()
             .includes(props.filterStr.toLowerCase()) ||
           row.homeOdds?.toString()
             .toLowerCase()
             .includes(props.filterStr.toLowerCase()) ||
           row.visitorOdds?.toString()
             .toLowerCase()
             .includes(props.filterStr.toLowerCase()))
        );
      })
      .slice(
        currentPage * rowsPerPage,
        currentPage * rowsPerPage + rowsPerPage
      )
      .map((row,i) => {
        const shouldRenderContent =
          row.gameStat === "B" ||
          (previousRow === null || row.leagueDescription !== previousRow.leagueDescription || row.description !== previousRow.description);

        previousRow = row;

        return (
          <React.Fragment>
            {shouldRenderContent && (
              <>
              <TableRow>
                <TableCell
                  colSpan="14"
                  className={` ${" schedule-banner classes.tableRow"} `}
                  >
                  <Time value={row.gameDateTime} format="DD/MM/YYYY" />
                  {" " + row.leagueDescription}
                </TableCell>
              </TableRow>
              <TableRow>
               <TableCell
                 colSpan="14"
                 className={` ${" classes.tableRow !border-b !text-black !border-b-black !font-semibold"} `}
                 style={{
                  backgroundColor: windowsColorToHex(
                                              row.gameStat !== "O" && row.gameColor
                                                ? row.gameColor?.bkColor
                                                : row.gameType?.bkColor
                                            ),
                  color: windowsColorToHex(row.gameType?.fkColor),
                }}
                 >
                 {row.description}
               </TableCell>
             </TableRow>
             </>

            )}
            {row.description && (
              <TableRow
                className={` ${
                  row.gameStat === "B"
                    ? " schedule-banner classes.tableRow"
                    : "classes.tableRow"
                } ${
                  row.idGame === props.lastChangedGamedID
                    ? "row-recent"
                    : ""
                }`}
              >
                <TableCell
                  colSpan="14"
                  className={` ${
                    row.gameStat === "B"
                      ? " schedule-banner classes.tableRow"
                      : "classes.tableRow game-description"
                  } `}
                />
              </TableRow>
            )}
            <TableRow
              ref={(el) => (rowRefs.current[row.idGame] = el)}
              style={{
                backgroundColor: windowsColorToHex(
                                            row.gameStat !== "O" && row.gameColor
                                              ? row.gameColor?.bkColor
                                              : row.gameType?.bkColor
                                          ),
                color: windowsColorToHex(row.gameType?.fkColor),
              }}
              className={` ${
                row.gameStat === "B"
                  ? " schedule-banner classes.tableRow"
                  : getStyle(row.gameStat, row.gameDateTime)
              }  ${
                  isGameDateTimePassed(row.gameDateTime) ? "!bg-blue-600 !text-black" : ""
                }${
                row.idGame === props.lastChangedGamedID
                  ? "row-recent"
                  : ""
                }
                ${highlightRow === row.idGame ? "highlight" : ""}`}
              key={row.idGame}
              // onClick={(event) =>
              //   handleClickCheckEvent(
              //     event,
              //     row.idGame,
              //     row.idLeague,
              //     row.parentGame,
              //     row.homeNumber,
              //     row.visitorNumber,
              //     row.visitorOdds
              //   )
              // }
              checked={isSelected(row.idGame, row.visitorNumber)}
            >
              {row.gameStat !== "B" ? (
                <React.Fragment>
                  <TableCell>
                    <label>
                      <StyledCheckbox
                        checked={isSelected(
                          row.idGame,
                          row.visitorNumber
                        )}
                        onChange={(event) =>
                          handleClickCheckEvent(
                            event,
                            row.idGame,
                            row.idLeague,
                            row.parentGame,
                            row.homeNumber,
                            row.visitorNumber,
                            row.visitorOdds,
                            row,
                            i
                          )}
                      />
                      <Time
                        value={row.gameDateTime}
                        format="DD/MM/YY HH:mm"
                      />
                    </label>
                  </TableCell>
                  <TableCell>
                    <span className="rotation-badge">{row.visitorNumber}</span>
                  </TableCell>
                </React.Fragment>
              ) : ( " ")}
              {row.gameStat !== "B" ? (
                <TableCell>
                  {row.visitorTeam}
                  <br></br>
                  {row.homeOdds}
                </TableCell>
              ) : (
                <TableCell
                  colSpan="14"
                  className={` ${
                    row.gameStat === "B"
                      ? " schedule-banner classes.tableRow"
                      : "classes.tableRow"
                    } `}
                  component="th"
                  scope="row"
                >
                  {row.visitorTeam} {row.homeTeam}
                </TableCell>
              )}
              {row.gameStat !== "B"  ? (
                <TableCell className={classes.headerCell}>
                  {props.IdSport !== "PROP" ? (
                    <DelayInput
                      minLength={1}
                      type="number"
                      delayTimeout={2000}
                      className={`w-[100px] ${
                        row.gameStat !== "TNT" &&
                        row.gameStat !== "PROP"
                          ? " schedule-text-box-input"
                          : "schedule-text-box-input-tnt"
                      } `}
                      value={
                        row.visitorOdds === 0 || row.visitorOdds === null
                          ? ""
                          : row.visitorOdds
                      }
                      onKeyDown={(event) => {
                        const inputs = document.querySelectorAll(
                          ".schedule-text-box-input, .schedule-text-box-input-tnt"
                        );
                        const currentIndex = Array.from(inputs).indexOf(
                          event.target
                        );
                        if (event.ctrlKey && event.key.toLowerCase() === "l") {
                            event.preventDefault();
                            GetLinesHistoryVisitor(row, 4, row.visitorNumber);  
                            return;
                        }
                        if (event.key === "Enter") {
                          //  updateML(
                          //    row.idGame,
                          //    row.overOdds,
                          //    props.IdLinetype,
                          //    event.target.value,
                          //    props.IdSport,
                          //    row.visitorNumber,
                          //    4,
                          //    8,
                          //    1,
                          //    0,
                          //    row.homeNumber,
                          //    row.idGameType,
                          //    8,
                          //    5,
                          //    event
                          //  );

                          event.preventDefault();
                          sendAllUpdates(row, event.target.value);
                          
                          //props.announce(row.idGame, props.IdLinetype);
                        } else if (event.key === "Tab") {
                          event.preventDefault();
                          // saveTempUpdate(row, event.target.value);

                          if (currentIndex !== -1 && inputs[currentIndex + 1]) {
                            inputs[currentIndex + 1].focus();
                          }
                        } else if (event.key === "ArrowDown") {
                          event.preventDefault();
                          if (
                            currentIndex !== -1 &&
                            inputs[currentIndex + 1]
                          ) {
                            inputs[currentIndex + 1].focus();
                          }
                        } else if (event.key === "ArrowUp") {
                          event.preventDefault();
                          if (
                            currentIndex !== -1 &&
                            inputs[currentIndex - 1]
                          ) {
                            inputs[currentIndex - 1].focus();
                          }
                        } else if (
                          event.key === "+" ||
                          event.key === "-"
                        ) {
                          const stringValue =
                            event.target.value.trim();
                          if (stringValue === "") {
                            return;
                          }
                          event.preventDefault();
                          const currentValue =
                            parseFloat(event.target.value) || 0;
                          const newValue =
                            event.key === "+"
                              ? currentValue + 1 // Aumentar valor
                              : currentValue - 1; // Disminuir valor
                          event.target.value = newValue;
                          event.target.dispatchEvent(
                            new Event("input", { bubbles: true })
                          );
                        }
                      }}
                      onChange={(event) => {
                        saveTempUpdate(row, event.target.value);
                        setValueHasChanged(true);
                      }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
              ) : (
                ""
              )}

              {row.gameStat !== "B" ? (
                <TableCell className={classes.headerCell} style={{ backgroundColor: 'white' }} >
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => {
                      setHomeTeam(row.homeTeam);
                      setVisitorTeam(row.visitorTeam);
                      setselectedIdGame(row.idGame);
                      setselectedPlay(4);
                      setPoints(row.visitorOdds);
                      setIsCharting(true);
                    }}
                  >
                    {row.mlVisitorAction}
                  </Link>

                </TableCell>
                
                
              ) : (
                  ""
                )}
                {row.gameStat !== "B" ? (
                <TableCell className={classes.headerCell} style={{ backgroundColor: 'white' }} >
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => {
                      setHomeTeam(row.homeTeam);
                      setVisitorTeam(row.visitorTeam);
                      setselectedIdGame(row.idGame);
                      setselectedPlay(4);
                      setPoints(row.visitorOdds);
                      setIsCharting(true);
                    }}
                  >
                    {row.mlVisitorCount}
                  </Link>

                </TableCell>
                
                
              ) : (
                  ""
                )}
            </TableRow>
          </React.Fragment>
            );
          })}
          </TableBody>

        </Table>
        {props && props.data && (
          <div>
            <TablePagination
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={pageNumbers.length}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onChangePage={handleClick}
              onChangeRowsPerPage={handleChange}
            />
          </div>
        )}
        {
          lineHistoryModal && (
            <div className="modal-line">
              <div className="modal-line-card bg-white">
                 <div className="flex justify-between ">
                  <h3>Lines History:</h3>
                  <span onClick={()=> setLineHistoryModal(false)} className="font-normal text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-all rounded-full w-6 h-6 flex items-center justify-center">x</span>
                 </div>
                 <div className="table-container">
                  <table className="odds-table">
                    <thead>
                      <tr>
                        <th>Time</th>
                        <th>{rowSelected.VisitorTeam}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mergedRows.map((r, idx) => (
                        <tr key={idx}>
                          <td>{fmt(r.time)}</td>
                          <td>{r.visitor}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>

              </div>
            </div>
          )
        }
      </div>
    </React.Fragment>
  );
}
